import React, { useState, useEffect } from "react";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { Container, Modal, Button, Form } from 'react-bootstrap';

import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { registerLocale } from "react-datepicker";

import { getStripePromise } from "../utils/getStripePromise"; // adjust path as needed
import { api } from  "../services/api";

import es from "date-fns/locale/es";
import en from "date-fns/locale/en-US";
import pl from "date-fns/locale/pl";
import ca from "date-fns/locale/ca";

registerLocale("es", es);
registerLocale("en", en);
registerLocale("pl", pl);
registerLocale("ca", ca);


const PaymentForm = ({ clientSecret, reservationId, onSuccess, translate, lang }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handlePayment = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;
    setProcessing(true);

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.href,
        payment_method_data: {
          billing_details: {
            name,
            email
          }
        }
      },
      redirect: "if_required"
    });

    if (!error) {
      await api.put(`/api/reservations/${reservationId}/confirm`, { name, email });
      onSuccess();
    } else {
      alert(error.message);
    }

    setProcessing(false);
  };

  return (
    <Form onSubmit={handlePayment}>
      <Form.Group className="mb-3">
        <Form.Label>{translate('reservationAndPayment.name')}</Form.Label>
        <Form.Control
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>{translate('reservationAndPayment.email')}</Form.Label>
        <Form.Control
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <PaymentElement />
      </Form.Group>
      <Button type="submit" variant="success" disabled={processing || !stripe}>
        {processing ? "Processing..." : "Pay Now"}
      </Button>
    </Form>
  );
};

const ReservationForm = ({ translate, lang }) => {

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [occupiedDates, setOccupiedDates] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [reservationId, setReservationId] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [stripePromise, setStripePromise] = useState(null);

  
  useEffect(() => {
    getStripePromise(lang).then((stripe) => {
      setStripePromise(stripe);
    });
  }, [lang]);

  const refreshOccupiedDates = async () => {
    const res = await api.get("/api/occupied-dates");
    setOccupiedDates(res.data.map((date) => new Date(date)));
  };

  useEffect(() => {
    api.get("/api/occupied-dates")
      .then((response) => {
        setOccupiedDates(response.data.map((date) => new Date(date)));
      })
      .catch((error) => {
        console.error("Error fetching occupied dates:", error);
      });
  }, []);

  const isDateDisabled = (date) => {
    return occupiedDates.some((occupiedDate) =>
      date.toDateString() === occupiedDate.toDateString()
    );
  };

  const hasOccupiedInRange = () => {
    if (!startDate || !endDate) return false;
    return occupiedDates.some((d) => d >= startDate && d <= endDate);
  };

  const calculateNights = () => {
    console.log("start date", endDate - startDate)
    if (!startDate || !endDate) return 0;
    const diffTime = Math.abs(endDate - startDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  const iterateDates = (startDate, endDate) => {

    const current = new Date(startDate);
    const end = new Date(endDate);
    const pricesPerNight = [];

    while (current < end) {
      pricesPerNight.push(getPriceForDate(current));
      current.setDate(current.getDate() + 1); // move to next day
    }
    console.log("prices ", pricesPerNight);
    return pricesPerNight;
  }

  const subtotal = () => iterateDates(startDate, endDate).reduce((acc, val) => acc + val, 0);;

  const createTempReservation = async () => {
    const formatDate = (d) => d.toLocaleDateString('sv-SE');

    const res = await api.post("/api/reservations/temp", {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    });
    setReservationId(res.data.id);
  };
  const getPriceForDate = (date) => {

    const seasons = {
      highSeason: { monthDays: [5, 6, 7] },
      middleSeason: { monthDays: [9, 10, 12] },
      lowSeason: { monthDays: [1, 2, 3, 4, 5, 11] }
    };

    let season = null;
    let price = 0;

    for (const [key, value] of Object.entries(seasons)) {
      if (value.monthDays.includes(date.getMonth())) {
        season = key;
        break;
      }
    }

    switch (season) {
      case 'highSeason':
        price = 250;
        break;
      case 'middleSeason':
        price = 200;
        break;
      case 'lowSeason':
        price = 150;
        break;
      default:
        price = 500; // fallback
    }
    return price;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (!startDate || !endDate || startDate >= endDate) {
      alert("Please select valid dates");
      return;
    }

    if (startDate < today) {
      alert("You cannot select dates in the past unless you have a time machine ;)")
      return;
    }

    if (hasOccupiedInRange()) {
      alert("Selected range includes unavailable dates. Please choose different dates.");
      setEndDate(null);
      return;
    }
    const createTempReservation = async () => {
      const formatDate = (d) => d.toLocaleDateString('sv-SE');
      const res = await api.post("/api/reservations/temp", {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate)
      });
      setReservationId(res.data.id);
      return res.data.id; // return the ID
    };


    try {

      const reservationId = await createTempReservation();
      const params = new URLSearchParams();
      params.append("amount", (calculateNights() * 100).toString());
      params.append("reservationId", reservationId);

      const response = await api.post("/api/payments/create-checkout-session", params, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });

      setClientSecret(response.data.clientSecret);
      setShowModal(true);
      setPaymentSuccess(false);
    } catch (error) {
      alert("Failed to start reservation: " + error.message);
      console.error(error);
    }
  };

  const handleModalClose = async () => {
    if (!paymentSuccess && reservationId) {
      await api.delete(`/api/reservations/${reservationId}`);
    }
    setShowModal(false);
  };

  return (
    <Container className="d-flex justify-content-center"
      style={{ transform: 'translateX(-10px)' }}>
      <div className="card p-4 shadow">
        <h4 className="text-center mb-3">{translate('calendar.title')}</h4>
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">{translate('calendar.checkin')}</label><br />
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                renderDayContents={(day, date) => (
                  <div className="text-center">
                    <div>{day}</div>
                    <div style={{ fontSize: '0.6em', color: '#888' }}>
                      €{getPriceForDate(date)}
                    </div>
                  </div>
                )}
                locale={lang}
                filterDate={(date) => !isDateDisabled(date)}
                className="form-control"
                excludeDates={occupiedDates}
                placeholderText="Select check-in date"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">{translate('calendar.checkout')}</label><br />
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                renderDayContents={(day, date) => (
                  <div className="text-center">
                    <div>{day}</div>
                    <div style={{ fontSize: '0.6em', color: '#888' }}>
                      €{getPriceForDate(date)}
                    </div>
                  </div>
                )}
                locale={lang}
                minDate={startDate ? new Date(startDate) : new Date()}
                filterDate={(date) => !isDateDisabled(date)}
                className="form-control"
                excludeDates={occupiedDates}
                placeholderText="Select check-out date"
              />
            </div>
          </div>
          <button type="submit" className="btn btn-primary w-100">
            {translate('calendar.book')}
          </button>
        </form>
      </div>

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{paymentSuccess ? "Payment Successful" : "Reservation & Payment"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {paymentSuccess ? (
          
              <div dangerouslySetInnerHTML={{ __html: translate('reservationAndPayment.paymentSucess') }} />
          
          ) : (
            stripePromise && clientSecret && (
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <p><strong>{translate('reservationAndPayment.checkin')}</strong> {startDate?.toLocaleDateString()}</p>
              <p><strong>{translate('reservationAndPayment.checkout')}</strong> {endDate?.toLocaleDateString()}</p>
              <p><strong>{translate('reservationAndPayment.totalNights')}</strong> {calculateNights()}</p>
              <p><strong>{translate('reservationAndPayment.subtotal')}</strong> €{subtotal().toFixed(2)}</p>
              {clientSecret && (
                <PaymentForm
                  clientSecret={clientSecret}
                  reservationId={reservationId}
                  onSuccess={async () => {
                    await refreshOccupiedDates();
                    setPaymentSuccess(true);
                  }}
                  translate={translate}
                  lang={lang}
                />
              )}
            </Elements>
            )
          )}
        </Modal.Body>
        {paymentSuccess && (
          <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
              Close
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </Container>
  );
};

export default ReservationForm;
